// extracted by mini-css-extract-plugin
module.exports = {"infographic":"Infographic-module__infographic___3EZM8","pointer":"Infographic-module__pointer___3p7LM","img-circle":"Infographic-module__img-circle___16ONJ"};